import api from './api';

const adminCalendarService = {
  // Create agency event
  createEvent: async (eventData) => {
    const response = await api.post('/admin/calendar/events', eventData);
    return response.data;
  },

  // Get all agency events with filters
  getEvents: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    if (filters.agent_id) params.append('agent_id', filters.agent_id);
    if (filters.event_type) params.append('event_type', filters.event_type);
    
    const response = await api.get(`/admin/calendar/events?${params.toString()}`);
    return response.data;
  },

  // Get specific agent's calendar
  getAgentEvents: async (agentId, filters = {}) => {
    const params = new URLSearchParams();
    if (filters.start_date) params.append('start_date', filters.start_date);
    if (filters.end_date) params.append('end_date', filters.end_date);
    
    const response = await api.get(`/admin/calendar/agents/${agentId}/events?${params.toString()}`);
    return response.data;
  },

  // Update event
  updateEvent: async (eventId, updates) => {
    const response = await api.put(`/admin/calendar/events/${eventId}`, updates);
    return response.data;
  },

  // Delete event
  deleteEvent: async (eventId) => {
    const response = await api.delete(`/admin/calendar/events/${eventId}`);
    return response.data;
  },

  // Get event responses summary
  getEventResponses: async (eventId) => {
    const response = await api.get(`/admin/calendar/events/${eventId}/responses`);
    return response.data;
  },

  // Get list of agents for targeting
  getAgentsList: async () => {
    const response = await api.get('/admin/calendar/agents');
    return response.data;
  }
};

export default adminCalendarService;
